import { Resizable } from 're-resizable';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

export const OverlayPlayer = styled.div``;

OverlayPlayer.Container = styled.div.attrs(({ coordinate }) => ({
  style: {
    top: `${coordinate.y}px`,
    left: `${coordinate.x}px`,
  },
}))`
  position: absolute;
  // It should be above the progress bar and create clip green bar but below create clip modal
  z-index: 10;
  padding: 8px;
  background: #00000050;

  &:active {
    cursor: grab;
  };
`;

OverlayPlayer.ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 0;
`;

OverlayPlayer.ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background-color: transparent;
  color: white;
  font-size: 16px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: #f2f2f230;
  }
`;

OverlayPlayer.Resizable = styled(Resizable)`

  &.minimized {
    width: 0 !important;
    min-width: initial !important;
    height: 0 !important;
    min-height: initial !important;
  }
`;

OverlayPlayer.Video = styled.video` // .video-js-overlay
  width: 100%;
  height: 100%;
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out;

  &.vjs-fullscreen .vjs-tech {
    width: 100%;
    height: 100%;
  }

  & .vjs-tech {
    width: 100%;
    height: 100%;
    transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
  }

  &.minimized {
    width: 0;
    height: 0;

    &.vjs-tech {
      width: initial;
      height: 0;
      transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
    }
  }

  &.vjs-fill {
    flex: 1;
  }

  & .vjs-load-progress {
    display: none !important;
  }

  & .vjs-remaining-time,
  & .vjs-control-bar {
    display: none;
  }
`;

OverlayPlayer.Icon = styled(Icon)`
  &&& {
    margin: 0;
  }
`;
